import { Link, useLocation } from "wouter";
import { ArrowLeft, Compass, LayoutDashboard } from "lucide-react";
import { t } from "@/lib/i18n";

/**
 * Unknown routes used to redirect to the dashboard silently, which hid broken
 * links and made a mistyped URL look like a working one.
 */
export function NotFoundPage() {
  const [location] = useLocation();
  return <div className="not-found">
    <span className="not-found-icon"><Compass className="ui-icon"/></span>
    <h1>{t("not_found_title")}</h1>
    <p>{t("not_found_body")}</p>
    <code className="not-found-path">{location}</code>
    <div className="not-found-actions">
      <button className="secondary-button" type="button" onClick={() => window.history.back()}><ArrowLeft className="ui-icon"/>{t("btn_go_back")}</button>
      <Link className="primary-button" href="/dashboard"><LayoutDashboard className="ui-icon"/>{t("nav_dashboard")}</Link>
    </div>
  </div>;
}
